/* eslint-disable */

import React from "react"
import PropTypes from "prop-types"
import { graphql, useStaticQuery } from "gatsby"
import FocusPPOriginal from "./focusPPOriginal"
import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 2500 },
    items: 4,
  },
  desktop: {
    breakpoint: { max: 2500, min: 1600 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1600, min: 768 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },
}

const EpisodeListPPOriginal = ({ carouselRef, afterChange, onClickPlay }) => {
  const data = useStaticQuery(graphql`
    query {
      storefront {
        blog(handle: "PolarPro-Originals") {
          title
          handle
          articles(first: 250) {
            edges {
              node {
                handle
                title
                content
                contentHtml
                image {
                  src
                }
                videoUrl: metafield(
                  namespace: "global"
                  key: "pp-originals-video-url"
                ) {
                  key
                  value
                }
                seriesType: metafield(
                  namespace: "global"
                  key: "pp-originals-series-type"
                ) {
                  key
                  value
                }
                seriesNumber: metafield(
                  namespace: "global"
                  key: "pp-originals-series-number"
                ) {
                  key
                  value
                }
                by: metafield(namespace: "global", key: "pp-originals-by") {
                  key
                  value
                }
                byImg: metafield(
                  namespace: "global"
                  key: "pp-originals-by-img"
                ) {
                  key
                  value
                }
              }
            }
          }
        }
      }
    }
  `)

  return (
    <div>
      <Carousel
        responsive={responsive}
        focusOnSelect={true}
        draggable={true}
        arrows={false}
        ref={carouselRef}
        afterChange={afterChange}
      >
        {data.storefront.blog.articles.edges.map((edge, index) => {
          return (
            <div key={index}>
              <FocusPPOriginal article={edge} onClickPlay={onClickPlay} />
            </div>
          )
        })}
      </Carousel>
    </div>
  )
}

export default EpisodeListPPOriginal
